module.exports = __webpack_public_path__ + "img/rounded-edit-icon.b064ff4e.png";